/* eslint-disable import/no-duplicates */
import Gfcr from './Gfcr'
import NewIndicatorSetModal from './Gfcr'

export default Gfcr
export { NewIndicatorSetModal }
